import { Api } from "@/services/api.js";

class Stores extends Api
{
  merchantId = process.env.VUE_APP_MERCHANT_ID;

  constructor() {
    super();
  }

  /**
   * @returns {Promise<StoreList>}
   */
  getStoreList(uuid = '') {
    const config = {
      method: 'GET',
      url: `${this.apiHost}/stores/v1/merchants/${this.merchantId}/members/${uuid}/stores`,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    return this.$http(config);
  }

  /**
   * @returns {Promise<StoreApplication>}
   */
  getStoreData(uuid = '') {
    const config = {
      method: 'GET',
      url: `${this.apiHost}/stores/v1/merchants/${this.merchantId}/stores/${uuid}/application`,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    return this.$http(config);
  }

  getAccessUsers(storeId) {
    const config = {
      method: 'GET',
      url: `${this.apiHost}/stores/v2/merchants/${this.merchantId}/stores/${storeId}/managers`,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    return this.$http(config);
  }

  addAccessUrl(storeId, bodyData) {
    const config = {
      method: 'POST',
      url: `${this.apiHost}/stores/v2/merchants/${this.merchantId}/stores/${storeId}/invitations`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: bodyData
    };

    return this.$http(config);
  }

  delAccessUser(storeId, memberUuid) {
    const config = {
      method: 'DELETE',
      url: `${this.apiHost}/stores/v2/merchants/${this.merchantId}/stores/${storeId}/managers/${memberUuid}`,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    return this.$http(config);
  }
}

export const stores = new Stores();
